import React from 'react';

type ConfirmDialogProps = {
  visible: boolean;
  title?: string;
  message?: string;
  confirmText?: string;
  cancelText?: string;
  loading?: boolean;
  zIndex?: number;
  onConfirm: () => void | Promise<void>;
  onCancel: () => void;
};

const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
  visible,
  title = 'Confirmar',
  message = 'Tem a certeza que deseja continuar?',
  confirmText = 'Confirmar',
  cancelText = 'Cancelar',
  loading = false,
  zIndex = 3000,
  onConfirm,
  onCancel,
}) => {
  if (!visible) return null;
  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex }} onClick={onCancel}>
      <div onClick={(e) => e.stopPropagation()} style={{ width: '94%', maxWidth: 460, background: '#fff', borderRadius: 16, overflow: 'hidden', boxShadow: '0 14px 50px rgba(0,0,0,0.25), 0 0 0 1px rgba(0,0,0,0.06)' }}>
        <div style={{ padding: 18, borderBottom: '1px solid #eef2f7' }}>
          <h3 style={{ margin: 0, fontSize: 18 }}>{title}</h3>
        </div>
        <div style={{ padding: 18, color: '#374151' }}>{message}</div>
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 10, padding: 18, borderTop: '1px solid #eef2f7' }}>
          <button onClick={onCancel} disabled={loading} style={{ padding: '8px 14px', borderRadius: 10, border: '1px solid #e5e7eb', background: '#f3f4f6', cursor: 'pointer' }}>{cancelText}</button>
          <button onClick={onConfirm} disabled={loading} style={{ padding: '8px 14px', borderRadius: 10, border: 0, background: '#ef4444', color: '#fff', cursor: 'pointer' }}>{loading ? 'A processar...' : confirmText}</button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDialog;
